import React from "react"

import SelectMenu from './forms/select'
import CheckBoxInput from './forms/checkbox'
import EmailInput from './forms/email'
import PasswordInput from './forms/password'
import TextInput from './forms/text'
import SubmitButton from './forms/submit-button'
import SecondaryButton from './forms/secondary-button'
import ToolTip from './forms/tooltip'
import Error from './forms/error'
import AnalyticEvent , {DirectCall} from './forms/analytics'

const ErrorMessages = {
    FailedFormSubmission : "We're missing some information we need to process your form.",
    TechnicalProblemErrorMessage : "Something technical went wrong."
};

export  {
    SelectMenu,
    CheckBoxInput,
    EmailInput,
    PasswordInput,
    TextInput ,
    SubmitButton,
    SecondaryButton,
    ToolTip,
    Error,
    AnalyticEvent,
    DirectCall,
    ErrorMessages
}